// extracted by mini-css-extract-plugin
export default {"info":"thank-you_info__7Wfem","contact":"thank-you_contact__c8f9Q"};